// THEME
export const GET_THEME = "GET_THEME";
export const CHANGE_THEME = "CHANGE_THEME";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const CHANGE_MENU_ACTIVE = "CHANGE_MENU_ACTIVE";
export const GET_MAX_HEIGHT_EXPANDED = "GET_MAX_HEIGHT_EXPANDED";
export const SET_MAX_HEIGHT_EXPANDED = "SET_MAX_HEIGHT_EXPANDED";

// DATA
export const GET_ATTENDANTS = "GET_ATTENDANTS";
export const GET_PLACES = "GET_PLACES";
export const GET_QUEUE = "GET_QUEUE";
export const GET_SERVICES = "GET_SERVICES";
export const GET_PIE_DATA = "GET_PIE_DATA";
export const GET_BAR_DATA = "GET_BAR_DATA";
export const GET_CALENDAR_DATA = "GET_CALENDAR_DATA";
export const FILTER_PLACES_SENT = "FILTER_PLACES_SENT";
export const ATTENDANTS_RECIEVED = "ATTENDANTS_RECIEVED";
export const CALENDAR_RECIEVED = "CALENDAR_RECIEVED";
export const PLACES_RECIEVED = "PLACES_RECIEVED";
export const QUEUE_RECIEVED = "QUEUE_RECIEVED";
export const QUEUE_INITIAL_RECIEVED = "QUEUE_INITIAL_RECIEVED";
export const SERVICES_RECIEVED = "SERVICES_RECIEVED";
export const PIE_DATA_RECIEVED = "PIE_DATA_RECIEVED";
export const BAR_DATA_RECIEVED = "BAR_DATA_RECIEVED";
export const CHANGE_FILTER_SEARCH_OPTION = "CHANGE_FILTER_SEARCH_OPTION";
export const CHANGE_FILTER_PLACE = "CHANGE_FILTER_PLACE";
export const CHANGE_SERVICE_PLACE = "CHANGE_SERVICE_PLACE";
export const CHANGE_FILTER_STATE = "CHANGE_FILTER_STATE";
export const UPDATE_FILTER_SEARCH_QUERY = "UPDATE_FILTER_SEARCH_QUERY";
export const UPDATE_SELECTED_CALENDAR = "UPDATE_SELECTED_CALENDAR";
